import $ from 'jquery'

// Uncheck all other checkboxes whose ID starts with _authorized_for_completion_approval
$(document).on('turbo:load', function() {
  const completionCheckboxes = $('[id$=_authorized_for_completion_approval]')
  completionCheckboxes.change(function() {
    completionCheckboxes.not(this).prop('checked', false)
  })
})
